import { loaded } from '@ck/lib.app-config';
import '@ck/lib.environment';

loaded.then(() => {
  // Environment detection depends on loading of the app config file and its override, which means it's asynchronous.
  // Because of that, we only load the main app after that config is loaded and the environment is determined.
  // This ensures that application code can rely on the environment values, without resorting to all kinds of async workarounds.
  import('./init');
});
